import { InfoTooltip } from "app/components/React/Tooltip/InfoTooltip/InfoTooltip";
import { i18nFilter } from "app/filters/i18nFilter";
import { FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import styled from "styled-components";
import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import DurationService, { BasicDurations } from "app/services/DurationService";

const { carbon } = colorsPalettes;

const Title = styled.span`
    ${setFontVariant("h6", carbon[300])};
`;

const Container = styled(FlexRow)`
    gap: 8px;
    align-items: center;
    padding: 12px 0;
`;

export const ItemsHeader = () => {
    const i18n = i18nFilter();
    const durations = DurationService.getDurationData(BasicDurations.LAST_MONTH);
    return (
        <Container>
            <Title>{durations.forWidget}</Title>
            <InfoTooltip
                infoText={i18n("industry.research.homepage.benchmark.title.tooltip")}
                infoIconContainer={FlexRow}
            />
        </Container>
    );
};
